import React from "react";
import moment from "moment";

export default ({ payment, openPaymentDetailsModal, key }) => (
  <tr className="payment-row" key={key}>
    <td className="acct-txt-sm payment-cell">
      {moment(payment.date).format("MMM D, YYYY")}
    </td>
    <td
      className="acct-txt-sm payment-cell acct-pg-edit-link"
      onClick={openPaymentDetailsModal.bind(null, payment.id)}
    >
      {payment.id}
    </td>
    <td className="acct-txt-sm payment-cell">{payment.status}</td>
    <td className="acct-txt-sm payment-cell">${payment.amount}</td>
  </tr>
);
